export const statusForFunder = (funder) => (funder.archivedAt ? 'ARCHIVED' : 'ACTIVE')
